/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;
const API = `${url}/${"medHandOff"}`;

const state = {
  dialog: null,
  item: [], //medhandoff data
  inventoryItem: [],
  medications: [],
  medhandOffItem: {},
  isLoading: false,
  snackbar: { show: false, text: "", color: "deep-purple accent-4" },
  outgoingHandOffMeds: [],
  incomingHandOffMeds: [],
  selectedMedHandOff: null,
  disabled: true,
};

const getters = {
  allClientMedHandOffData: (state) => state.item,
  getMedications: (state) =>
    state.medications.filter((item) => item.MedInventory != null),
};

const actions = {
  async fetchMedicationItem({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/medications/all/${id}/group`);
      commit("SET_MEDICATIONS", response.data.medications);
      commit("SET_LOADING", false);
      return response;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },

  async fetchItems({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      let serverURL = `${API}/client/${id}`;
      const response = await axios.get(serverURL);
      commit("SET_ALL", response.data.results);
      commit("SET_LOADING", false);
      return response;
    } catch (error) {
      console.error(e.response);
      return error.response;
    }
  },
  
  async fetchItem({}, id){
    try {
      let serverURL = `${API}/${id}`;
      const response = await axios.get(serverURL);
      return response.data.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async saveItem({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${API}/`, data);
      if (response.data.success) {
        commit("SAVE_ITEM", data);
      }
      commit("SET_LOADING", false);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async updateItem({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.patch(
        `${API}/update/${data.id}/${data.type}`,
        data.medication
      );
      commit("SET_LOADING", false);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async deleteItem({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.delete(`${API}/${id}`);
      if (response.data.success) {
        commit("DELETE_ITEM", id);
        commit("SET_LOADING", false);
      }
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async updateInventoryItem({ commit }, data) {
    try {
      const response = await axios.put(`${API}/medinventory`, data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },
};

const mutations = {
  SET_SNACKBAR(state, { show, text, color }) {
    let timeout = 0;

    if (state.snackbar.show) {
      state.snackbar.show = false;
      timeout = 100;
    }
    setTimeout(() => {
      state.snackbar = {
        show: show,
        text: text,
        color: color,
      };
    }, timeout);
  },

  SET_MEDICATIONS(state, data) {
    state.medications = data.filter((item) => item.IsActive != false);
  },
  SET_ALL(state, data) {
    state.item = data;
  },
  SAVE_ITEM(state, data) {
    // state.item = data;
    state.item.push(data);
  },
  UPDATE_ITEM(state, data) {
    state.item.splice(
      state.item.findIndex((item) => item._id === data.id),
      1
    );
  },
  DELETE_ITEM(state, id) {
    state.item.splice(
      state.item.findIndex((item) => item._id === id),
      1
    );
  },
  SET_DIALOG(state, data) {
    state.dialog = data;
  },

  SET_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_HAND_OFF_ITEM(state, data) {
    state.medhandOffItem = data;
  },

  SET_OUTGOING_HAND_OFF_MEDS(state, data) {
    state.outgoingHandOffMeds = data;
  },

  SET_INCOMING_HAND_OFF_MEDS(state, data) {
    state.incomingHandOffMeds = data;
  },

  SET_SELECTED_MEDHANDOFF(state, data){
    state.selectedMedHandOff = data
  },

  SET_DISABLE(state, data) {
    state.disabled = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
